module.exports = __webpack_public_path__ + "static/img/qes_bj2.f787574.png";